import { AlertTriangle } from "lucide-react";

export default function Disclaimer() {
  return (
    <div
      data-testid="medical-disclaimer"
      className="fixed bottom-0 left-0 right-0 z-50 flex items-center justify-center gap-2 border-t border-yellow-200 bg-yellow-50 px-4 py-2 text-xs font-medium text-yellow-900 sm:text-sm"
    >
      <AlertTriangle className="h-4 w-4 shrink-0" strokeWidth={2} />
      <span>
        Demo / educational tool only — not a certified medical device. Evidence modelled on
        DeVita, Hellman &amp; Rosenberg's Cancer: Principles &amp; Practice of Oncology. Always consult a licensed physician.
      </span>
    </div>
  );
}
